import { CVData, CVSection, CVSectionType, CV_LIMIT } from '../types';

export const isPersonalInfoComplete = (data: CVData): boolean => {
  const { fullName, jobTitle, email } = data.personalInfo;

  return Boolean(fullName.trim() && jobTitle.trim() && email.trim());
};

export const isSectionEmpty = (section: CVSection): boolean => {
  if (section.type === 'skills') {
    return section.entries.length === 0 || section.entries.every((e) => !e.title.trim());
  }

  return section.entries.length === 0 || section.entries.every((e) => !e.title.trim());
};

export const getNonEmptySections = (data: CVData): CVSection[] => {
  return data.sections.filter((section) => !isSectionEmpty(section));
};

export const hasEmptySection = (sections: CVSection[]): boolean => {
  return sections.some((section) => isSectionEmpty(section));
};

export const getAvailableSectionTypes = (usedTypes: CVSectionType[]): CVSectionType[] => {
  const allTypes: CVSectionType[] = ['experience', 'education', 'skills', 'projects', 'certifications', 'languages', 'hobbies', 'interests'];
  const usedSet = new Set(usedTypes);

  return allTypes.filter((type) => !usedSet.has(type));
};

export const canCreateCV = (currentCount: number): boolean => {
  return currentCount < CV_LIMIT;
};

export const getCVLimitMessage = (currentCount: number): string | null => {
  if (currentCount >= CV_LIMIT) {
    return `CV limit reached (${currentCount}/${CV_LIMIT}). Delete an existing CV to create a new one.`;
  }

  return null;
};

export const validateCVTitle = (title: string): string | null => {
  const trimmed = title.trim();

  if (!trimmed) {
    return 'Title is required';
  }

  if (trimmed.length > 100) {
    return 'Title must be 100 characters or less';
  }

  return null;
};
